import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

export default function Layout({ children, className = "bg-white" }) {
  return (
    <div className={`min-h-screen flex flex-col font-sans text-gray-900 selection:bg-teal-100 selection:text-teal-900 ${className}`}>
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <Footer />
    </div>
  );
}
